<template>
    <!-- 排班表 -->
    <div class="treatment-schedule">
        <div class="contentbar" v-watermark>
            <div class="user">
                <div class="head">
                    <div class="name">{{ table.detail.name }}</div>
                    <div class="desc">
                        <span>{{ table.detail.clinicalTitleName }}</span>
                        <span v-if="table.detail.clinicalTitleName && table.detail.deptText">-</span>
                        <span>{{ table.detail.deptText }}</span>
                    </div>
                </div>
                <div class="foot">
                    <div class="cell">
                        <span>工号：</span>
                        <span>{{ table.detail.staffNo }}</span>
                    </div>
                    <div class="cell">
                        <span>部门：</span>
                        <span>互联网诊疗中心</span>
                    </div>
                </div>
            </div>
            <div class="date">
                <van-button size="mini" @click="onTableDatePage(true)">
                    <span>上月</span>
                    <van-icon name="arrow-left" />
                </van-button>
                <div class="selected" @click="onTableDateShow">{{ formatTime(search.month).format('YYYY年MM月') }}</div>
                <van-button size="mini" @click="onTableDatePage(false)">
                    <van-icon name="arrow" />
                    <span>下月</span>
                </van-button>
            </div>
            <div class="calendar">
                <table class="table">
                    <thead>
                        <tr>
                            <th v-for="(item, index) in ['一', '二', '三', '四', '五', '六', '日']" :key="index">星期{{ item }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in calendar.list" :key="index">
                            <td v-for="(itm, idx) in item" :key="idx">
                                <div class="cell" v-if="itm.dateType === 'current'">
                                    <div class="day">{{ itm.day }}</div>
                                    <div class="item" @click="onItemClick(table.dates[itm.date])">
                                        <template v-if="table.dates[itm.date]">
                                            <treatment-schedule-item class="item-box" :class="{ border: table.dates[itm.date] }" :value="table.dates[itm.date].scNo" />
                                        </template>
                                        <div class="item-box none" v-else>-</div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="statistics">
                <div class="title">本月排班数据统计</div>
                <table class="table">
                    <thead>
                        <tr>
                            <th>本月排班</th>
                            <th>{{ workDaysComputed }}天</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in table.times" :key="index">
                            <td>
                                <div class="cell">
                                    <div class="icon">
                                        <treatment-schedule-dot :color="item.color" />
                                    </div>
                                    <span>{{ item.label }}</span>
                                </div>
                            </td>
                            <td>{{ onTableTotal(item.code) }}{{ onTableTotal(item.code) ? '天' : '' }}</td>
                        </tr>
                        <tr>
                            <td>
                                <div class="cell">外派目的地</div>
                            </td>
                            <td>
                                <div class="dist">
                                    <div class="p" v-for="(itm, idx) in dispatchComputed" :key="idx">
                                        <span>{{ itm.channelName }}</span>
                                        <span>（{{ itm.dateStr }}）</span>
                                    </div>
                                    <p v-if="!dispatchComputed.length">-</p>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <van-action-sheet v-model="date.show">
            <div class="months">
                <van-datetime-picker v-model="date.active" type="year-month" title="选择年月" @confirm="onTableDateConfirm" @cancel="date.show = false" />
            </div>
        </van-action-sheet>

        <van-action-sheet v-model="dispatch.show">
            <div class="dispatchs">
                <div class="item date">日期：{{ dispatch.row.date }}</div>
                <div class="item title">外派至：{{ (channel.list.find((row) => row.code === dispatch.row.channelCode) || {}).name || '-' }}</div>
                <div class="item desc">
                    <span>时间：</span>
                    <span>{{ formatTime(dispatch.row.startTime).format('HH:mm') }}</span>
                    <span>-</span>
                    <span>{{ formatTime(dispatch.row.endTime).format('HH:mm') }}</span>
                </div>
            </div>
        </van-action-sheet>
    </div>
</template>
<script>
import { scheduleTimeInit, scheduleDatesFormat } from '@/hooks/schedule'
import { formatTime } from '@/hooks/function'
import request from '@/utils/request'
import treatmentScheduleItem from '@/components/treatment/schedule/item.vue'
import treatmentScheduleDot from '@/components/treatment/schedule/dot.vue'

export default {
    components: {
        treatmentScheduleItem,
        treatmentScheduleDot
    },
    data() {
        return {
            formatTime,
            search: {
                month: ''
            },
            table: {
                detail: {},
                dates: {},
                origin: {},
                loading: false,
                times: [],
                // 禁用日期，当前月份
                disabledDate: formatTime().format('YYYY-MM-01 00:00:00')
            },
            channel: {
                list: []
            },
            date: {
                show: false,
                active: ''
            },
            calendar: {
                list: [],
                origin: []
            },
            dispatch: {
                show: false,
                row: {}
            }
        }
    },
    computed: {
        diffComputed() {
            return JSON.stringify(this.table.origin) !== JSON.stringify(this.table.dates);
        },
        // 在班天数
        workDaysComputed() {
            let count = 0;
            for (let k in this.table.dates) {
                if (['BC0001', 'BC0002', 'BC0003', 'BC0004', 'BC0007', 'BC0008'].includes(this.table.dates[k].scNo)) count++;
            }
            return count;
        },
        dispatchComputed() {
            let res = [];
            for (let k in this.table.dates) {
                if (this.table.dates[k].scNo === 'BC0003') {
                    const obj = JSON.parse(JSON.stringify(this.table.dates[k]));
                    obj.channelName = (this.channel.list.find((row) => row.code === obj.channelCode) || {}).name || '-';
                    obj.dateStr = formatTime(obj.date).format('MM月DD日');
                    res.push(obj)
                }
            }
            return res;
        }
    },
    mounted() {
        this.search.month = formatTime(new Date()).format('YYYY-MM');
        this.init();
    },
    methods: {
        init() {
            this.onTableTimeGet().then(() => {
                return this.onTableListGet();
            }).then(() => {
                this.onChannelGet();
            });
            this.calendar.origin = this.onCalendarGet(this.search.month);
            this.calendar.list = this.onCalendarDateToWeek(this.calendar.origin);
        },
        onTableDatePage(isPrev = false) {
            const date = new Date(this.search.month);
            let year = date.getFullYear();
            let month = date.getMonth();
            let gap = isPrev ? -1 : 1;
            month += gap;
            if (month < 0) {
                month = 11;
                year--;
            } else if (month >= 12) {
                year++;
                month = 0;
            }
            this.search.month = formatTime(new Date(year, month)).format('YYYY-MM');
            this.onTableDateChange();
        },
        onTableDateChange() {
            this.init();
        },
        onTableTimeGet() {
            return new Promise((resolve, reject) => {
                if (this.table.times.length) {
                    resolve(true);
                } else {
                    request({
                        method: 'get',
                        url: '/doctor-service/schedule/allScheduleConfig'
                    }).then(({ data, code, message }) => {
                        if (code === 0) {
                            this.table.times = scheduleTimeInit(data);
                            resolve(true);
                        } else {
                            this.$toast.error(message);
                            reject(false);
                        }
                    }).catch(() => {
                        reject(false);
                    })
                }
            })
        },
        onTableListGet() {
            return new Promise((resolve, reject) => {
                request({
                    method: 'get',
                    url: `/doctor-service/schedule/getStaffSchedule?date=${formatTime(this.search.month).format('YYYY-MM-01')}&staffNo=${this.$store.state.assistantNo}`
                }).then(({ data, code, message }) => {
                    if (code === 0) {
                        this.table.detail = data;
                        this.table.origin = scheduleDatesFormat(data.scheduleList);
                        this.table.dates = scheduleDatesFormat(data.scheduleList);
                        resolve(true);
                    } else {
                        this.$toast.error(message);
                        reject(false);
                    }
                }).catch(() => {
                    reject(false);
                })
            })
        },
        onTableDateShow() {
            this.date.active = new Date(this.search.month);
            this.date.show = true;
        },
        onTableDateConfirm() {
            this.search.month = formatTime(this.date.active).format('YYYY-MM');
            this.date.show = false;
            this.onTableDateChange();
        },
        onTableTotal(code) {
            let count = 0;
            for (let k in this.table.dates) {
                if (this.table.dates[k].scNo === code) count++;
            }
            return count;
        },
        // 获取日历数据
        onCalendarGet(time) {
            const res = [];
            const { year, month, days } = this.onCalendarDateGet(time);
            const week = formatTime([year, month, 1].join('-')).get('weekday'); // 当月1号是周几

            // 上月
            const preMonth = this.onCalendarDateGet(this.onCalendarNextDayGet(year, month, 1, true));
            const preNum = (week || 7) - 1;
            for (let i = 0; i < preNum; i++) {
                let day = preMonth.days - i;
                res.unshift(this.onCalendarDataGet(preMonth.year, preMonth.month, day, 'last'))
            }

            // 当月
            for (let i = 0; i < days; i++) {
                let day = i + 1;
                res.push(this.onCalendarDataGet(year, month, day, 'current'))
            }

            // 下月
            const nextMonth = this.onCalendarDateGet(this.onCalendarNextDayGet(year, month, days));
            const grids = Math.ceil((days + preNum) / 7) * 7;
            const nextNum = grids - days - preNum;
            for (let i = 0; i < nextNum; i++) {
                let day = i + 1;
                res.push(this.onCalendarDataGet(nextMonth.year, nextMonth.month, day, 'next'))
            }
            return res;
        },
        onCalendarDateGet(time) { // 获取年月天数
            const date = formatTime(time);
            return {
                year: date.get('year'), // 年
                month: date.get('month'), // 月
                days: date.daysInMonth() // 天数
            }
        },
        // 获取日历每一天的数据
        onCalendarDataGet(year, month, day, type) {
            return {
                date: formatTime(new Date(year, month - 1, day)).format('YYYY-MM-DD'),
                year: year,
                month: month,
                day: day.toString().padStart(2, '0'),
                dateType: type
            }
        },
        // 下一天或上一天获取
        onCalendarNextDayGet(year, month, day, prev) {
            const oneDayTime = 24 * 60 * 60 * 1000;
            return new Date(year, month - 1, day).getTime() + oneDayTime * (prev ? -1 : 1);
        },
        // 一维数组转换为二位数组
        onCalendarDateToWeek(list) {
            let index = 0;
            let count = 0;
            const res = [];
            for (let i = 0; i < list.length; i++) {
                if (!res[index]) res[index] = [];
                res[index].push(JSON.parse(JSON.stringify(list[i])));
                if (count < 6) {
                    count++;
                } else { // 下周
                    count = 0;
                    index++;
                }
            }
            return res;
        },
        onChannelGet() {
            return new Promise((resolve, reject) => {
                request({
                    method: 'get',
                    url: '/marketing-service/api/channel/getChannelsByLevel',
                    params: {
                        level: 1,
                        channelName: ''
                    }
                }).then(({ data, code }) => {
                    if (code === 0) {
                        this.channel.list = data;
                        resolve(true);
                    } else {
                        reject(false);
                    }
                }).catch(() => {
                    reject(false);
                })
            })
        },
        onItemClick(row) {
            if (row && row.scNo === 'BC0003') {
                this.dispatch.row = JSON.parse(JSON.stringify(row));
                this.dispatch.show = true;
            }
        }
    }
}
</script>
<style lang="scss" scoped>
$main-color: #3d6dfa;
$background-color: #f2f2f2;
$border-color: #dcdfe6;
.treatment-schedule {
    min-height: 100vh;
    background: #fff;
    font-size: 18px;
    padding-bottom: 20px;
    .header {
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        border-bottom: 1px solid #e5e5e5;
    }
    .contentbar {
        padding: 15px 15px 0;
        .user {
            .head,
            .foot {
                display: flex;
                align-items: center;
            }
            .head {
                .name {
                    font-weight: bold;
                }
                .desc {
                    margin-left: 20px;
                }
            }
            .foot {
                margin-top: 15px;
                .cell {
                    width: 50%;
                }
            }
        }
        .date {
            display: flex;
            align-items: center;
            margin-top: 30px;
            font-weight: bold;
            .van-button {
                border: none;
                color: #999;
                padding: 0 5px;
                font-size: 14px;
                .van-icon {
                    font-size: 16px;
                }
            }
            .selected {
                display: flex;
                align-items: center;
                margin: 0 5px;
                height: 30px;
                color: #333;
                border-radius: 4px;
                font-size: 22px;
            }
        }
        .calendar {
            margin-top: 20px;
            font-size: 12px;
            .table {
                border-collapse: collapse;
                table-layout: fixed;
                width: 100%;
                td,
                th {
                    border: 1px solid $border-color;
                }
                th {
                    padding: 10px 0;
                }
                td {
                    padding: 8px;
                    text-align: center;
                }
                .item {
                    margin: 0 auto;
                    &-box {
                        padding: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-radius: 4px;
                        box-sizing: border-box;
                        &.border {
                            border: 1px solid transparent;
                        }
                        &.none {
                            color: #ccc;
                            transform: scale(2);
                        }
                        .p {
                            text-align: center;
                        }
                    }
                }
                .day {
                    font-weight: bold;
                    margin-bottom: 5px;
                    color: #999;
                }
            }
        }
        .statistics {
            margin-top: 25px;
            .title {
                font-weight: bold;
                display: flex;
                align-items: center;
                &::before {
                    content: "";
                    width: 4px;
                    height: 14px;
                    border-radius: 10px;
                    background: $main-color;
                    margin-right: 10px;
                }
            }
            .table {
                table-layout: fixed;
                border-collapse: collapse;
                width: 100%;
                margin-top: 15px;
                td,
                th {
                    border: 1px solid $border-color;
                    &:first-child {
                        width: 25%;
                    }
                }
                th {
                    padding: 12px;
                }
                td {
                    text-align: center;
                }
                .cell {
                    width: 100%;
                    height: 100%;
                    min-height: 45px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .icon {
                        margin-right: 8px;
                    }
                }
                .dist {
                    padding: 10px;
                    .p {
                        margin: 5px 0;
                    }
                }
            }
        }
    }
    .dispatchs {
        padding: 25px;
        min-height: 40vh;
        .item {
            &:not(:first-child) {
                margin-top: 20px;
            }
            &:first-child {
                font-weight: bold;
            }
        }
    }
    .footer {
        position: sticky;
        bottom: 0;
        z-index: 2;
        text-align: center;
        padding: 15px;
        background: #fff;
        .van-button {
            min-width: 100px;
            background: $background-color;
            border: none;
        }
    }
}
</style>